export default __webpack_public_path__ + "static/media/vbb-4.69dd9390.jpg";